<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-header">
            <h1 class="title" v-if="currentProduct.id_producto_promo !== 0">Editar producto</h1>
            <h1 class="title" v-if="currentProduct.id_producto_promo == 0">Crear producto</h1>
            <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup()" />
          </div>
          
          <div class="popup-body">
            <div class="form-row">
              <div class="input-group half">
                <label>Título*</label>
                <input
                  type="text"
                  required
                  v-model="currentProduct.titulo"/>
              </div>
              <div class="input-group half">
                <label>Precio*</label>
                <input
                  type="number"
                  step="0.01"
                  inputmode="decimal"
                  required
                  v-model="currentProduct.precio"/>
              </div>
            </div>

            <div class="form-row">
              <div class="input-group third">
                <label>Fecha</label>
                <input
                  type="date"
                  required
                  class="expiration-date"
                  v-model="currentProduct.fecha" />
              </div>
              <div class="input-group third">
                <label>Hora</label>
                <input
                  type="time"
                  v-model="currentProduct.hora"/>
              </div>
              <div class="input-group third">
                <label>Duración</label>
                <input
                  type="text"
                  v-model="currentProduct.duracion"/>
              </div>
            </div>

            <div class="form-row">
              <div class="input-group half">
                <label>Selección mínima*</label>
                <input
                  type="number"
                  step="1"
                  v-model="currentProduct.selec_minima"/>
              </div>
              <div class="input-group half">
                <label>Selección máxima*</label>
                <input
                  type="number"
                  step="1"
                  v-model="currentProduct.selec_maxima"/>
              </div>
            </div>

            <div class="form-row">
              <div class="input-group half">
                <label>Stock máximo*</label>
                <input
                  type="number"
                  step="1"
                  v-model="currentProduct.stock_maximo"/>
              </div>
              <div class="input-group half">
                <label>Posición*</label>
                <input
                  type="number"
                  step="1"
                  v-model="currentProduct.posicion"/>
              </div>
            </div>

            <div class="form-row">
              <div class="input-group full">
                <label>Email empresa opcional</label>
                <input
                  type="text"
                  v-model="currentProduct.email_empresa_opcional"/>
              </div>
            </div>

            <div class="form-row checkboxes">
              <div class="checkbox-group">
                <label class="checkbox-label">
                  <input class="active_checkbox" type="checkbox" name="activo" v-model="currentProduct.obligatorio"> 
                  Obligatorio
                </label>
              </div>
              <div class="checkbox-group">
                <label class="checkbox-label">
                  <input class="active_checkbox" type="checkbox" name="activo" v-model="currentProduct.oculto"> 
                  Oculto
                </label>
              </div>
              <div class="checkbox-group">
                <label class="checkbox-label">
                  <input class="active_checkbox" type="checkbox" name="activo" v-model="currentProduct.forzar_completo"> 
                  Forzar completo
                </label>
              </div>
              <div class="checkbox-group">
                <label class="checkbox-label">
                  <input class="active_checkbox" type="checkbox" name="activo" v-model="currentProduct.draft"> 
                  En revisión
                </label>
              </div>
            </div>
          </div>

          <div class="popup-footer">
            <button @click="closePopup()" class="secondary_button">Cancelar</button>
            <button @click="saveClicked()" class="main_button">Guardar</button>
          </div>
        </div>
        <TwoButtonPopup
          :title="twoButtonTitle"
          :message="twoButtonMessage"
          :acceptButton="twoButtonAcceptButton"
          @acceptCallback="() => twoButtonConfirmed()"
          :cancelButton="twoButtonCancelButton"
          @cancelCallback="() => twoButtonCancelled()"
          />

      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import TwoButtonPopup from "@/components/common/TwoButtonPopup.vue";


  const props = defineProps({
    product: Object,
  });
  
  const emit = defineEmits(['productChanged', 'productPopupCancelled', 'productErrorHappened']);

  const visible = ref(false);
  const currentProduct = ref(null);

  watch(() => props.product, (newVal) => {
    currentProduct.value = newVal;
    visible.value = !!newVal;
  });
  
  const closePopup = () => {
    visible.value = false;
    currentProduct.value = null;
    emit('productPopupCancelled');
  };

  const saveClicked = async () => {
    if (currentProduct.value.titulo.trim() === ""
      || (currentProduct.value.precio === null || currentProduct.value.precio === undefined || isNaN(currentProduct.value.precio))
      || (currentProduct.value.selec_minima === null || currentProduct.value.selec_minima === undefined || isNaN(currentProduct.value.selec_minima))
      || (currentProduct.value.selec_maxima === null || currentProduct.value.selec_maxima === undefined || isNaN(currentProduct.value.selec_maxima))
      || (currentProduct.value.stock_maximo === null || currentProduct.value.stock_maximo === undefined || isNaN(currentProduct.value.stock_maximo))
      || (currentProduct.value.posicion === null || currentProduct.value.posicion === undefined || isNaN(currentProduct.value.posicion))) {
      emit('productErrorHappened', 'Por favor, completa todos los campos obligatorios');
      return;
    }

    emit('productChanged', currentProduct.value);
    closePopup();
  }

  </script>
  
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .form-row {
    display: flex;
    gap: var(--spacing-md);
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .input-group.half {
    flex: 1;
  }

  .input-group.third {
    flex: 1;
  }

  .input-group.full {
    width: 100%;
  }

  label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-color-dark);
  }

  input {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid var(--gray);
    border-radius: var(--radius-md);
    font-family: inherit;
    font-size: 14px;
    transition: border-color var(--transition-fast);
  }

  input:focus {
    outline: none;
    border-color: var(--primary-color);
  }

  input:disabled {
    background-color: var(--almost-white);
    color: var(--text-color-placeholder);
  }

  .checkboxes {
    margin-top: var(--spacing-sm);
    justify-content: space-between;
  }

  .checkbox-group {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: normal;
  }

  .active_checkbox {
    width: 20px;
    margin: 0;
  }

  .popup-footer {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .secondary_button, .main_button {
    width: auto;
    min-width: 120px;
  }

  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }
    
    .checkboxes {
      flex-direction: row;
      flex-wrap: wrap;
    }

    .checkbox-group {
      justify-content: flex-start;
      width: 100%;
      margin-bottom: 10px;
    }
  }
  </style>
  